export const appsAppGroupIdUserImportsDatatable = "/apps/:app_group_id/user_imports_datatable";
